// src/config/lockscreenConfig.js
const lockscreenConfig = {
  inactivityTimeoutMinutes: 1 // Tiempo en minutos para bloquear por inactividad
};

export default lockscreenConfig;